import * as React from 'react';
import { css, cx } from 'emotion';
import Typo from '@peachjar/ui/dist/lib/typography/TypographyRedux';

type Props = {
  children: React.ReactNode;
  className?: string;
};

const SubappHeader = ({ children, className }: Props) => (
  <Typo.Dark.Headline1 className={cx(classNames.subappHeader, className)}>
    {children}
  </Typo.Dark.Headline1>
);

SubappHeader.defaultProps = { className: '' };

const classNames = {
  subappHeader: css`
    padding: 4rem 0 2.5rem 0;
    margin: 0;
  `,
};

export default SubappHeader;
